import React, { useEffect, useState } from "react";
import globalStyles from "../styles/global.css";
import Footer from "./Footer";
import Header from "./Header";
import TabBar from "./TabBar";
import FileTab from "./file/FileTab";
import SettingsTab from "./settings/SettingsTab";
import useEmailArchive from "../hooks/useEmailArchive";
import useOfficeContext from "../hooks/useOfficeContext";
import { getItemId } from "../../shared/utils/officeHelpers";

export default function App() {
  const [activeTab, setActiveTab] = useState("file");
  const { displayName, initials, userEmail, itemId } = useOfficeContext();
  const {
    status,
    activeStep,
    result,
    errorMessage,
    isProcessing,
    processEmail,
    reset,
  } = useEmailArchive();

  useEffect(() => {
    reset();
  }, [itemId, reset]);

  const handleArchive = async (projectId) => {
    try {
      // Read from Office at click time — React `itemId` can lag behind the
      // mailbox item right after ItemChanged, which would archive the wrong message.
      const messageId = getItemId();
      await processEmail({ messageId, userEmail, projectId });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <style>{globalStyles}</style>
      <div className="addin-shell">
        <Header />
        <TabBar activeTab={activeTab} onTabChange={setActiveTab} />

        <main className="addin-content">
          {activeTab === "file" ? (
            <FileTab
              key={itemId}
              status={status}
              activeStep={activeStep}
              apiMessage={result?.message}
              errorMessage={errorMessage}
              isProcessing={isProcessing}
              onArchive={handleArchive}
              onReset={reset}
              emailFrom={displayName}
              emailSubject="Current message"
            />
          ) : (
            <SettingsTab
              // version={process.env.VERSION || "N/A"}
              // environment={process.env.APP_ENV || "N/A"}
              version={"N/A"}
              environment={"N/A"}
              accountEmail={userEmail}
            />
          )}
        </main>

        <Footer displayName={displayName} initials={initials} />
      </div>
    </>
  );
}
